import Errors from "../../utilities/constants/Errors";
import HttpClient from "../../utilities/functions/HttpClient";
import CustomToast from "../../utilities/components/CustomToast";
import { USERS_ENDPOINT } from "../../utilities/constants/ServerEndPoints";

const getBackendErrorMessage = (err) => {
  const data = err?.response?.data;

  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors[0];
  }

  return data?.message || null;
};

const handleUserRequestError = (err, setApiError) => {
  setApiError?.(true);
  const backendMessage = getBackendErrorMessage(err);

  switch (err?.response?.status) {
    case 400:
      CustomToast(backendMessage || "Please review your data and try again.", "error");
      return;
    case 401:
      CustomToast("Please sign in to continue.", "error");
      return;
    case 403:
      CustomToast(backendMessage || "You are not allowed to perform this action.", "error");
      return;
    case 404:
      CustomToast(backendMessage || Errors.NOT_FOUND_ERROR, "info");
      return;
    case 503:
      CustomToast(Errors.SERVICE_UNAVAILABLE_ERROR, "error");
      return;
    default:
      CustomToast(backendMessage || Errors.API_ERROR, "error");
  }
};

/**
 * Get user by id
 * @param {number} id - The id of the user to get.
 * @param {function} setUser - The function to set the user.
 * @returns
 */
export const getUserById = async (id, setUser) => {
  try {
    const response = await HttpClient.getAxiosClient().get(`${USERS_ENDPOINT}/${id}`);

    if (response.status === 200) {
      setUser(response.data);
    }
  } catch (err) {
    handleUserRequestError(err);
  }
};

/**
 * Update user
 * @param {object} user - The user to update.
 * @param {function} setApiError - The function to set the api error.
 * @param {function} setUser - The function to set the state.
 * @returns
 */
export const updateUser = async (user, setUser, setApiError) => {
  setApiError?.(false);

  try {
    const response = await HttpClient.getAxiosClient().put(
      `${USERS_ENDPOINT}/${user.userId}`,
      user,
    );

    if (response.status === 200) {
      CustomToast("User updated successfully.", "success");
      setUser(response.data);
    }
  } catch (err) {
    handleUserRequestError(err, setApiError);
  }
};
